module.exports = __webpack_public_path__ + "img/data-line.76219f43.svg";